module.exports = __webpack_public_path__ + "img/209.blockage_toilet.a4164a39.svg";